import { render, staticRenderFns } from "./SorteosNewOrEdit.vue?vue&type=template&id=3b3c8b87&"
import script from "./SorteosNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./SorteosNewOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports